import React from "react";
import "./AccountSetting.css";

import ProfileTab from "../../Components/ProfileSetting/ProfileSetting";

const AccountSetting = () => {
  return (
    <div className="account-setting-container">
            <div className="account-setting-pad">
            <span className="account-setting-title">Account Settings</span>
            <p className="account-setting-description">Edit your name, change your password and update profile</p>
            <ProfileTab />
            </div>
      </div>
  );
};

export default AccountSetting;
